import { render } from "./ProductsSelect.vue?vue&type=template&id=1bc90d8e"
import script from "./ProductsSelect.vue?vue&type=script&lang=js"
export * from "./ProductsSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__